import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';
import {ArchwizardModule} from 'angular-archwizard';
import {NgSelectizeModule} from 'ng-selectize';
import {DataTablesModule} from 'angular-datatables';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {CKEditorModule} from 'ckeditor4-angular';
import {DatePipe} from '@angular/common';

// Forms Component
import {FormElementsComponent} from './form-elements/form-elements.component';
import {FormWizard_Component} from './form-wizard/form-wizard.component';
import {FormAddReservationComponent} from './form-add-reservation/form-add-reservation.component';
import {FormStopComponent} from './form-stop/form-stop.component';
import {FormRouteComponent} from './form-route/form-route.component';
import {SharedModule} from '../shared/shared.module';
import {FormEditReservationComponent} from './form-edit-reservation/form-edit-reservation.component';
import {FormVehicleComponent} from './form-vehicle/form-vehicle.component';
import {FormEditPassengerComponent} from './form-edit-reservation/form-edit-passenger/form-edit-passenger.component';
import {FormRouteGroupComponent} from './form-route-group/form-route-group.component';
import {FormDispatchComponent} from './form-dispatch/form-dispatch.component';
import {FormDispatchGroupComponent} from './form-dispatch-group/form-dispatch-group.component';
import {FormCalendarComponent} from './form-calendar/form-calendar.component';
import {FormSearchBulkComponent} from './form-search-bulk/form-search-bulk.component';
import {FormCreateUserComponent} from './form-create-user/form-create-user.component';
import {FormEditUserComponent} from './form-edit-user/form-edit-user.component';
import {FormSettingComponent} from './form-setting/form-setting.component';
import {FormEditRouteComponent} from './form-edit-route/form-edit-route.component';
import {FormEditRouteGroupComponent} from './form-edit-route-group/form-edit-route-group.component';
import {FormEditDispatchGroupComponent} from './form-edit-dispatch-group/form-edit-dispatch-group.component';
import {FormSubPageComponent} from './form-sub-page/form-sub-page.component';
import {FormEditSubPageComponent} from './form-edit-sub-page/form-edit-sub-page.component';
import {GlobalModule} from '../global-components/global-components.module';
import {FormBlockedDateComponent} from './form-blocked-date/form-blocked-date.component';
import {FormEditTicketComponent} from './form-edit-reservation/form-edit-ticket/form-edit-ticket.component';
import {FormEditPaymentComponent} from './form-edit-reservation/form-edit-payment/form-edit-payment.component';
import {FormPaymentSquareComponent} from './form-payment-square/form-payment-square.component';
import {FormEditUploadComponent} from './form-edit-reservation/form-edit-upload/form-edit-upload.component';
import {FormSendEmailReservationComponent} from './form-send-email-reservation/form-send-email-reservation.component';
import {AgmCoreModule} from '@agm/core';
import {FormDiscountComponent} from './form-discount/form-discount.component';
import {FormAddRoutingComponent} from './form-add-reservation/form-add-routing/form-add-routing.component';
import {FormEditUserCommentComponent} from './form-edit-user-comment/form-edit-user-comment.component';
import {FormCalendarCommentComponent} from './form-calendar-comment/form-calendar-comment.component';
import {FormDateCommentComponent} from './form-date-comment/form-date-comment.component';
import {FormDateRouteCommentComponent} from './form-date-route-comment/form-date-route-comment.component';
import {FormLayoutsComponent} from './form-layouts/form-layouts.component';
import {FormDispatchMonthComponent} from './form-dispatch-month/form-dispatch-month.component';
import {FormEditVehicleComponent} from './form-edit-vehicle/form-edit-vehicle.component';
import {FormPicPageComponent} from './form-pic-page/form-pic-page.component';
import {
    FormListConfirmedChangeDateComponent
} from './form-list-confirmed-change-date/form-list-confirmed-change-date.component';
import {FormSendEmailBulkComponent} from './form-send-email-bulk/form-send-email-bulk.component';
import {FormEditRouteBulkComponent} from './form-edit-route-bulk/form-edit-route-bulk.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HttpModule,
        ArchwizardModule,
        NgSelectizeModule,
        NgbModule,
        ReactiveFormsModule,
        DataTablesModule,
        SharedModule,
        CKEditorModule,
        GlobalModule,
        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyCM-scNitwQiVFNoA2mhLM592J1oMW7bE4'
        }),
    ],
    declarations: [
        FormElementsComponent,
        FormAddReservationComponent,
        FormAddRoutingComponent,
        FormWizard_Component,
        FormDiscountComponent,
        FormStopComponent,
        FormRouteComponent,
        FormRouteGroupComponent,
        FormEditReservationComponent,
        FormVehicleComponent,
        FormEditPassengerComponent,
        FormDispatchComponent,
        FormDispatchGroupComponent,
        FormCalendarComponent,
        FormCalendarCommentComponent,
        FormDateCommentComponent,
        FormDateRouteCommentComponent,
        FormSearchBulkComponent,
        FormCreateUserComponent,
        FormEditUserComponent,
        FormEditUserCommentComponent,
        FormSettingComponent,
        FormEditRouteComponent,
        FormEditRouteGroupComponent,
        FormEditDispatchGroupComponent,
        FormSubPageComponent,
        FormEditSubPageComponent,
        FormBlockedDateComponent,
        FormEditTicketComponent,
        FormEditPaymentComponent,
        FormPaymentSquareComponent,
        FormEditUploadComponent,
        FormSendEmailReservationComponent,
        FormLayoutsComponent,
        FormDispatchMonthComponent,
        FormEditVehicleComponent,
        FormPicPageComponent,
        FormListConfirmedChangeDateComponent,
        FormSendEmailBulkComponent,
        FormEditRouteBulkComponent
    ],
    exports: [
        FormAddReservationComponent,
        FormAddRoutingComponent,
        FormStopComponent,
        FormRouteComponent,
        FormDiscountComponent,
        FormRouteGroupComponent,
        FormEditReservationComponent,
        FormVehicleComponent,
        FormEditPassengerComponent,
        FormDispatchComponent,
        FormDispatchGroupComponent,
        FormCalendarComponent,
        FormCalendarCommentComponent,
        FormDateCommentComponent,
        FormDateRouteCommentComponent,
        FormSearchBulkComponent,
        FormCreateUserComponent,
        FormEditUserComponent,
        FormEditUserCommentComponent,
        FormSettingComponent,
        FormEditRouteComponent,
        FormEditRouteGroupComponent,
        FormEditDispatchGroupComponent,
        FormSubPageComponent,
        FormEditSubPageComponent,
        FormBlockedDateComponent,
        FormEditTicketComponent,
        FormEditPaymentComponent,
        FormPaymentSquareComponent,
        FormEditUploadComponent,
        FormSendEmailReservationComponent,
        FormDispatchMonthComponent,
        FormEditVehicleComponent,
        FormPicPageComponent,
        FormListConfirmedChangeDateComponent,
        FormSendEmailBulkComponent,
        FormEditRouteBulkComponent
    ],
    providers: [
        DatePipe
    ]
})
export class Forms_Module {
}
